import { render, staticRenderFns } from "./SuppliersList.vue?vue&type=template&id=40f83dbc&scoped=true"
import script from "./SuppliersList.vue?vue&type=script&lang=js"
export * from "./SuppliersList.vue?vue&type=script&lang=js"
import style0 from "./SuppliersList.vue?vue&type=style&index=0&id=40f83dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f83dbc",
  null
  
)

export default component.exports